import React from 'react';
// TODO: Import @material-ui from design-system folder
/* eslint-disable restrict-imports/restrict-imports */
import { Dialog, DialogTitle, DialogContent, makeStyles } from '@material-ui/core';
import {
  TextCollectionFormParams,
  TextCollectionAttachment,
} from '@scale/shared/types/params/textcollection';
import TextCollectionForm from './TextCollectionForm';
import { TextCollectionAnnotation } from '@scale/shared/types/response/textcollection';
import { TextCollectionAnnotationsOrCallback } from '@scale/shared/types/textCollection';
import { TextCollectionDispatch } from './reducer';
import { Button } from 'design-system';

interface TextCollectionModalFormProps {
  open: boolean;
  formParams: TextCollectionFormParams;
  dispatch: TextCollectionDispatch;
  annotations: Record<string, TextCollectionAnnotation>;
  annotationsRef: React.MutableRefObject<Record<string, TextCollectionAnnotation>>;
  setAnnotations: (annotations: TextCollectionAnnotationsOrCallback) => void;
  onSubmit?: (fieldId: string) => void;
  onClose?: (fieldId: string) => void;
  bboxFieldToEdit: string | null;
  setBboxFieldToEdit: (fieldId: string | null) => void;
  attachment: TextCollectionAttachment;
  readOnly: boolean;
}

const TextCollectionModalForm: React.FC<TextCollectionModalFormProps> = ({
  open,
  formParams,
  annotations,
  annotationsRef,
  setAnnotations,
  dispatch,
  onSubmit,
  onClose,
  bboxFieldToEdit,
  setBboxFieldToEdit,
  attachment,
}) => {
  const classes = useStyles();

  return (
    <Dialog
      open={open}
      onClose={() => onClose && onClose(formParams.form_id)}
      classes={{ paper: classes.dialogContainer }}
    >
      <DialogTitle
        disableTypography
        id="customized-dialog-title"
        classes={{ root: classes.dialogTitle }}
      >
        {formParams.title}
      </DialogTitle>
      <DialogContent dividers classes={{ root: classes.dialogContent }}>
        <div className={classes.formContents}>
          <TextCollectionForm
            breadcrumbs={[]}
            setBreadcrumbs={() => {}}
            disabled={false}
            fields={formParams.fields}
            annotations={annotations}
            annotationsRef={annotationsRef}
            setAnnotations={setAnnotations}
            onRequestBack={() => {}}
            onRequestDelete={() => {}}
            autoComplete={() => []}
            readOnly={false}
            reviewMode={false}
            quickAddFieldSets={[]}
            dispatch={dispatch}
            deleteAnnotations={() => {}}
            bboxFieldToEdit={bboxFieldToEdit}
            setBboxFieldToEdit={setBboxFieldToEdit}
            attachment={attachment}
          />
        </div>
        <Button
          onClick={() => onSubmit && onSubmit(formParams.form_id)}
          className={classes.submitButton}
          type={'primary'}
        >
          SUBMIT
        </Button>
      </DialogContent>
    </Dialog>
  );
};

const useStyles = makeStyles({
  dialogContainer: {
    maxWidth: '664px;',
    minHeight: '296px',
    maxHeight: '496px',
  },
  dialogTitle: {
    maxHeight: 80,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  dialogContent: {
    display: 'flex',
    flexDirection: 'column',
  },
  headerText: {
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '20px',
  },
  formContents: {
    flexGrow: 1,
    marginBottom: 36,
  },
  submitButton: {
    marginBottom: 8,
  },
});

export default TextCollectionModalForm;
